import React, { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Card, Button, Form } from "antd";

interface SigCanvasModal {
  onClose?: () => void;
  onOk?: (info: any) => void;
}

const SigCanvasModal: React.FC<SigCanvasModal> = ({ onClose, onOk }) => {
  const form = Form.useFormInstance();
  const sigCanvas = useRef<SignatureCanvas | null>(null);

  const clear = () => {
    sigCanvas.current?.clear();
  };

  const save = () => {
    const signatureURL = sigCanvas.current?.toDataURL("image/png");

    if (signatureURL) {
      if (onOk) {
        onOk(signatureURL);
      }
      if (onClose) {
        onClose();
      }
    }
  };
  const SignatureCanvas1 = SignatureCanvas as any;

  return (
    <div className="custom-override">
      <Card>
        <SignatureCanvas1
          ref={sigCanvas}
          penColor="black"
          canvasProps={{
            width: 450,
            height: 400,
            className: "sigCanvas",
          }}
        />
      </Card>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button className="btn_color" onClick={clear}>
          Xóa chữ ký
        </Button>
        <Button className="btn_color" onClick={save}>
          Lưu chữ ký
        </Button>
      </div>
    </div>
  );
};

export default SigCanvasModal;
